import { render, staticRenderFns } from "./Perfis.vue?vue&type=template&id=4ab8951c"
import script from "./Perfis.vue?vue&type=script&lang=js"
export * from "./Perfis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports